
import { Tabs } from "antd";
import DeviceApi from "../../../../api/DeviceApi";
import { DeviceDetailsWrapper, DeviceNameTitle, GoBackText, GoBackWrapper, TitleBar } from "./DeviceDetails.styled";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { LeftCircleFilled } from "@ant-design/icons";
import { useEffect, useState } from "react";
import ViewStateService from "../../../../services/view-state/ViewStateService";
import DeviceInformation from "./components/device-information/DeviceInformation";
import DeviceSettings from "./components/device-settings/DeviceSettings";
import RealtimeDeviceMetrics from "./components/realtime-device-metrics/RealtimeDeviceMetrics";
import HistoryDeviceMetrics from "./components/history-device-metrics/HistoryDeviceMetrics";
import WaveformFile from "./components/waveform-file/WaveformFile";
import OfflineMetricsDataFile from "./components/offline-device-metrics-management/OfflineMetricsDataFile";
import StringUtils from "../../../../util/StringUtils";

interface DeviceDetailsProps {
    onClose: ()=> void,
    onComplete: ()=> void
}

const DeviceDetails: React.FC<DeviceDetailsProps> = (props)=> {
    // api
    let navigate = useNavigate();
    let location = useLocation();
    let viewStateService = ViewStateService.getInstance();
    let deviceApi = new DeviceApi();

    // parameters
    let {deviceId} = useParams();
    let [searchParams] = useSearchParams();
    let defaultTabKey = searchParams.get('tab') || 'device-information';

    // state
    let [deviceView, setDeviceView] = useState(null);

    // events
    let loadDevice = async ()=> {
        if(!deviceId) {
            return;
        }

        let deviceView = (await deviceApi.getDeviceViewByDeviceId(deviceId)).data.data;
        setDeviceView(deviceView);
    }

    let onGoBack = ()=> {
        if(location.key=='default') {
            navigate("/device-management");
        } else {
            navigate(-1);
        }
    }
    
    useEffect(()=> {
        // set status bar title
        viewStateService.setStatusBarTitle('设备详情');

        // load device information according to device id parameter
        loadDevice();

    }, []);
    
    // render
    let tabItems = [
        {
            key: 'device-information',
            label: '设备信息',
            children: deviceView && <DeviceInformation deviceView={deviceView} />
        },
        {
            key: 'device-settings',
            label: '参数设置',
            children: deviceView && <DeviceSettings deviceView={deviceView} />
        },
        {
            key: 'device-metrics-realtime',
            label: '实时数据',
            children: deviceView && <RealtimeDeviceMetrics deviceView={deviceView} />
        },
        {
            key: 'device-metrics-history',
            label: '历史数据',
            children: deviceView && <HistoryDeviceMetrics deviceView={deviceView} />
        },
        {
            key: 'waveform-file',
            label: '波形文件',
            children: deviceView && <WaveformFile deviceView={deviceView} />
        },
        {
            key: 'offline-metrics-data-file',
            label: '离线数据文件',
            children: deviceView && <OfflineMetricsDataFile deviceView={deviceView} />
        }
    ];

    if (deviceView?.product?.settings) {
        let settings = JSON.parse(deviceView.product.settings);
        let settingsGroups = settings?.settingsGroups ?? [];
        if (settingsGroups.length <= 0) {
            let deviceSettingIndex = tabItems.findIndex(e=> e.key === 'device-settings');
            if (deviceSettingIndex > -1) {
                tabItems.splice(deviceSettingIndex, 1);
            }
        }
        if (settingsGroups.find(e=> StringUtils.equalsIgnoreCase(e.type, 'standard_adc_waveform')) == null) {
            let waveformFileIndex = tabItems.findIndex(e=> e.key === 'waveform-file');
            if (waveformFileIndex > -1) {
                tabItems.splice(waveformFileIndex, 1);
            }
        }
    }
    if (deviceView?.deviceTemplate?.nodeType != 'OFFLINE') {
        let offlineMetricsDataFileIndex = tabItems.findIndex(e=> e.key === 'offline-metrics-data-file');
        if (offlineMetricsDataFileIndex > -1) {
            tabItems.splice(offlineMetricsDataFileIndex, 1);
        }
    } else {
        let deviceSettingIndex = tabItems.findIndex(e=> e.key === 'device-settings');
        if (deviceSettingIndex > -1) {
            tabItems.splice(deviceSettingIndex, 1);
        }
    }

    if (deviceView?.deviceTemplate?.nodeType == 'OFFLINE') {
        let waveformFileIndex = tabItems.findIndex(e=> e.key === 'waveform-file');
        if (waveformFileIndex > -1) {
            tabItems.splice(waveformFileIndex, 1);
        }
    }

    return (
        <DeviceDetailsWrapper>
            <TitleBar>
                <GoBackWrapper onClick={onGoBack}>
                    <LeftCircleFilled style={{fontSize: '20px'}} />
                    <GoBackText>返回</GoBackText>
                </GoBackWrapper>
                <DeviceNameTitle>{deviceView?.device.name}</DeviceNameTitle>
            </TitleBar>
    
            { deviceView && 
                <Tabs
                    defaultActiveKey={defaultTabKey}
                    items={tabItems}
                    style={{flex: '1 1 auto', overflow: 'hidden'}}
                />
            }
        </DeviceDetailsWrapper>
    )
}

export default DeviceDetails;

